import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { HelmetProvider } from 'react-helmet-async';
// import { hydrate, render } from "react-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Auth0Provider
    domain="desirestore.us.auth0.com"
    clientId="QkJ9sYjmS8N16SBkkW2iU4XEKZi2lAGs"
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
   <BrowserRouter>
    <App />
  </BrowserRouter>
  </Auth0Provider>
  </HelmetProvider>
  </React.StrictMode>
);

// const rootElement = document.getElementById("root");
// if (rootElement.hasChildNodes()) {
//   hydrate(<App />, rootElement);
// } else {
//   render(<App />, rootElement);
// }


 
